import { render, staticRenderFns } from "./TheMainMenu.vue?vue&type=template&id=06a8364e&scoped=true&"
import script from "./TheMainMenu.vue?vue&type=script&lang=js&"
export * from "./TheMainMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheMainMenu.vue?vue&type=style&index=0&id=06a8364e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a8364e",
  null
  
)

export default component.exports